import React from 'react';

import { btnTypes } from '../../components/buttons/baseButton';
import { dataLayerPush } from '../../components/helpers';
import Carousel from '../../deprecated/carousel';
import * as ST from './styled';

class InterestingBlock extends React.Component {

    getGAParam = (action) => {
        const temp = action.split('/');
        return temp[temp.length - 1];
    }

    handleClick = (action) => {
        const gaParam = this.getGAParam(action);
        dataLayerPush({
            event: 'UAevent',
            category: 'add_to_packet',
            action: `clicked button ${gaParam}`,
        });
        window.open(action);
    }

    render() {
        const { list, blocksTitle } = this.props;

        const breakpoints = [
            { width: 0, slidesToShow: 1, showDots: true },
            { width: 767, slidesToShow: 2, showDots: false },
            { width: 1279, slidesToShow: 3, showDots: false },
        ];

        return (
            <ST.InterestingListWrapper>
                { blocksTitle && <ST.InterestingTitle data-test={'blocksTitle'}>{blocksTitle}</ST.InterestingTitle>}
                <ST.InterestingListContainer>
                    <Carousel data-test='Interesting-list' visibleCardWidth={1024} showArrows={false}
                        responsive={breakpoints} align='center'>
                        {list.map((item, index) =>
                            <div key={index}>
                                <ST.InterestingEl data-test={'intrestingElement'} withoutMargin={list.length - 1 === index}>
                                    <ST.InterestingTop back={item.background}>
                                        <ST.InterestingT>{item.title}</ST.InterestingT>
                                        <ST.InterestingDesc>{item.desc}</ST.InterestingDesc>
                                    </ST.InterestingTop>
                                    <ST.InterestingBottom>
                                        <ST.InterestingButton
                                            type={btnTypes.SECONDARY}
                                            onClick={() => this.handleClick(item.action)}
                                            data-test={'intrestingButton'}
                                            text={item.textButton}
                                        />
                                    </ST.InterestingBottom>
                                </ST.InterestingEl>
                            </div>)}
                    </Carousel>
                </ST.InterestingListContainer>
            </ST.InterestingListWrapper>
        );
    }
}

export default InterestingBlock;
